var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 45"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval 23 Copy",
    cx: 14.7787,
    cy: 14.7787,
    r: 12.7787,
    fill: "#86C250",
    stroke: "#86C250",
    strokeWidth: 2.55574
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined Shape"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8429 8.38965H13.7131V13.7141H8.38867V15.8439H13.7131V21.1683H15.8429V15.8439H21.1674V13.7141H15.8429V8.38965Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8429 8.38965H13.7131V13.7141H8.38867V15.8439H13.7131V21.1683H15.8429V15.8439H21.1674V13.7141H15.8429V8.38965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7131 8.38965V7.2992H12.6227V8.38965H13.7131ZM15.8429 8.38965H16.9334V7.2992H15.8429V8.38965ZM13.7131 13.7141V14.8046H14.8036V13.7141H13.7131ZM8.38867 13.7141V12.6237H7.29822V13.7141H8.38867ZM8.38867 15.8439H7.29822V16.9343H8.38867V15.8439ZM13.7131 15.8439H14.8036V14.7534H13.7131V15.8439ZM13.7131 21.1683H12.6227V22.2588H13.7131V21.1683ZM15.8429 21.1683V22.2588H16.9334V21.1683H15.8429ZM15.8429 15.8439V14.7534H14.7525V15.8439H15.8429ZM21.1674 15.8439V16.9343H22.2578V15.8439H21.1674ZM21.1674 13.7141H22.2578V12.6237H21.1674V13.7141ZM15.8429 13.7141H14.7525V14.8046H15.8429V13.7141ZM13.7131 9.4801H15.8429V7.2992H13.7131V9.4801ZM14.8036 13.7141V8.38965H12.6227V13.7141H14.8036ZM8.38867 14.8046H13.7131V12.6237H8.38867V14.8046ZM9.47912 15.8439V13.7141H7.29822V15.8439H9.47912ZM13.7131 14.7534H8.38867V16.9343H13.7131V14.7534ZM14.8036 21.1683V15.8439H12.6227V21.1683H14.8036ZM15.8429 20.0779H13.7131V22.2588H15.8429V20.0779ZM14.7525 15.8439V21.1683H16.9334V15.8439H14.7525ZM21.1674 14.7534H15.8429V16.9343H21.1674V14.7534ZM20.0769 13.7141V15.8439H22.2578V13.7141H20.0769ZM15.8429 14.8046H21.1674V12.6237H15.8429V14.8046ZM14.7525 8.38965V13.7141H16.9334V8.38965H14.7525Z",
    fill: "white",
    mask: "url(#path-2-inside-1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.cda0cbe8f2a59c5a2ed70e93820a64fc.svg";
export { ForwardRef as ReactComponent };